import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Box, Grommet } from "grommet";
import { normalizeColor } from "grommet/utils";
import * as React from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useUser } from "./account/AccountStore";
import DarkModeSwitch, { useDarkMode } from "./components/DarkModeSwitch";
import { NotFound, useIFrame, useQuery } from "./general/Helpers";
import Home from "./home/Home";
import Theme from "./utils/Theme";

const back = <FontAwesomeIcon icon={["fad", "arrow-left"]} size="lg"></FontAwesomeIcon>;

const BrowserNavigation = () => {
  const navigate = useNavigate();
  let { key } = useLocation();
  return (
    <>
      {key != "default" && (
        <Box direction="row" fill pad="small">
          <Anchor onClick={() => navigate(-1)}>{back}</Anchor>
        </Box>
      )}
    </>
  );
};

function App() {
  const [isDarkMode, toggleDarkMode] = useDarkMode();
  const [showDarkModeSwitch, setShowDarkModeSwitch] = React.useState(true);

  const user = useUser();

  return (
    <Grommet id="main" full theme={Theme} themeMode={isDarkMode ? "dark" : "light"}>
      <SkeletonTheme baseColor={normalizeColor("background-back", Theme, isDarkMode)} highlightColor={normalizeColor("background-front", Theme, isDarkMode)}>
        {showDarkModeSwitch && <DarkModeSwitch></DarkModeSwitch>}
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />}></Route>
          </Routes>
        </BrowserRouter>
      </SkeletonTheme>
    </Grommet>
  );
}

export default App;
